import React, { createRef } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";

import { Grid, Dialog, IconButton } from "@material-ui/core";
import { Images } from "config/images";

const DialogBack = props => {
	const classes = useStyles();
	const { handleClose, open } = props;
	const nodeRef = createRef();

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="customized-dialog-title"
			open={open}
			ref={nodeRef}
		>
			<Grid classes={{ root: classes.closeButton }}>
				<IconButton aria-label="close" onClick={handleClose}>
					<CloseIcon />
				</IconButton>
			</Grid>
			<Grid classes={{ root: classes.body }}>
				<img
					src={Images.icWarningLogin}
					alt={"icWarningLogin"}
					width={72}
				/>
				<Grid classes={{ root: classes.title }}>
					Bạn cần ký để hoàn tất xác nhận nhận thưởng CRM
				</Grid>
				<Grid style={{ padding: 10 }}>
					<Grid
						classes={{
							root: clsx(classes.btnSubmit)
						}}
						onClick={() => handleClose()}
					>
						Đóng
					</Grid>
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default DialogBack;
